import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiCall } from "Apis/BaseApi";
import { IPaginatedList } from "Apis/Models/IPaginatedList";
import {IQueryParams} from "./Models/IQueryParams";
import {ProjectSettlementSettingsDto} from "./Models/ProjectSettlementSettingsDto";

export const PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY = 'PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY '
export const useProjectSettlementSettings = (queryable: Partial<IQueryParams> | null = null) => {
    return useQuery<IPaginatedList<ProjectSettlementSettingsDto>>([PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY, queryable], async () => {
        return await apiCall<IPaginatedList<ProjectSettlementSettingsDto>>({
            url: `/projectSettlementSettings`,
            method: 'GET',
            queryParams: queryable
        })
    });
}

export const useSettlementSetting = (id: number) => {
    return useQuery<ProjectSettlementSettingsDto>([PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY, id], async () => {
        return await apiCall<ProjectSettlementSettingsDto>({
            url: `/projectSettlementSettings/${id}`,
            method: 'GET',
        })
    });
}

export const useSettlementSettingForProject = (id: number) => {
    return useQuery<ProjectSettlementSettingsDto>([PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY, id], async () => {
        return await apiCall<ProjectSettlementSettingsDto>({
            url: `/projectSettlementSettings/project/${id}`,
            method: 'GET',
        })
    });
}

export const useMutateProjectSettlementSettings = () => {
    
    const queryClient = useQueryClient();
    
    return useMutation(async (projectSettlementSettings: ProjectSettlementSettingsDto): Promise<ProjectSettlementSettingsDto> => {
        if (!projectSettlementSettings.id) {
            return await apiCall<ProjectSettlementSettingsDto>({
                url: `/projectSettlementSettings`,
                method: 'POST',
                data: projectSettlementSettings
            })
        } else {
            return await apiCall<ProjectSettlementSettingsDto>({
                url: `/projectSettlementSettings/${projectSettlementSettings.id}`,
                method: 'PUT',
                data: projectSettlementSettings
            })
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_SETTINGS_CACHE_KEY)
        }
    })
}